<template>
  <div class="mt-4">

    <b-row class="m-4 textSize" align="left">
      <b-col>
        <span>Clínica que recibe el trabajo<span style="color: red">*</span></span>
        <v-select id="clinica" name="clinica"
                  placeholder="Elige una clinica"
                  v-model="infoGeneral.clinicaSeleccionada"
                  :options="listaClinicas"
                  :reduce="(val) => val.idClinica"
                  label="nombreClinica"
                  @input="validarFlujo"
                  style="width: 95%"
                  :clearable="false"
                  :disabled="deshabilitado"

        />
      </b-col>
      <b-col>
        <span>Doctor que solicita el trabajo<span style="color: red">*</span></span>
        <v-select id="clinica" name="clinica"
                  placeholder="Elige un doctor"
                  v-model="infoGeneral.empleadoSeleccionado"
                  :options="listaDoctores"
                  :reduce="(val) => val.idEmpleado"
                  label="nombreEmpleado"
                  style="width: 95%"
                  :disabled="deshabilitado"
                  :clearable="false"
        />
      </b-col>
      <b-col>
        <span>Flujo<span style="color: red">*</span></span>
        <v-select v-model="infoGeneral.flujo" :options="opcionesFlujo"
                  :reduce="(esp) => esp.id"
                  label="nombre" :disabled="deshabilitado"
                  :clearable="false"
        />

      </b-col>
    </b-row>
    <b-row class="m-4 textSize" align="left">
      <span class="mr-2 ml-3">¿Esta ODT es provisional?</span>
      <b-form-checkbox
          v-model="infoGeneral.odtProvisional"
          name="odtProvisional"
          :value="true"
          class="ml-2"
          :disabled="deshabilitado"
      >
      </b-form-checkbox>
    </b-row>
    <b-row class="m-4">
      <b-col  align="center">
        <b-button variant="outline-primary" pill size="sm"
                  @click="siguiente()"
                  :disabled="infoGeneral.clinicaSeleccionada === null || infoGeneral.flujo === null || infoGeneral.empleadoSeleccionado === null || deshabilitado"
        >
          <span>Siguiente</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script >
export default {
  name: "InformacionGeneral",
  data: () => ({
    flujo: 1,
    opcionesFlujo: [],
    infoGeneral: {
      clinicaSeleccionada: null,
      empleadoSeleccionado: null,
      flujo: 1,
      odtProvisional: false,
      escaner: [],
    },
  }),
  props:{
    odtMadre: Object,
    listaClinicas: Array,
    listaDoctores: Array,
    datos: Object,
    deshabilitado: {
      type: Boolean,
      default: false
    },
    ap: Number,
  },
  created() {
    this.validarFlujo();
    if (this.odtMadre != null && this.odtMadre.infoGeneral !== null){
      this.infoGeneral = this.odtMadre.infoGeneral;
    }
  },
  watch:{
    "datos.infoTratamiento"(){
      this.infoGeneral.empleadoSeleccionado = this.datos.infoTratamiento.idEmpleado;
      this.validarFlujo();
    },
    "listaClinicas"(){
      let existeClinica = this.listaClinicas.filter(lc => lc.idClinica === this.$localStorageService.getIdClinica());
      if(existeClinica.length !== 0) {
        this.infoGeneral.clinicaSeleccionada = this.$localStorageService.getIdClinica();
      }
    }
  },
  methods: {
    validarFlujo(){
      this.opcionesFlujo = [{id: 1, nombre: 'Fisico'}];
      let clinica = this.listaClinicas.filter(lc => lc.idClinica === this.infoGeneral.clinicaSeleccionada)[0];
      if (clinica !== null && clinica !== undefined && this.datos.infoTratamiento != null) {
        this.infoGeneral.escaner = clinica.datosEscaner;

        if (clinica.flujoDigital && this.datos.infoTratamiento.puedeFlujoDigital) {
          this.opcionesFlujo = [{id: 1, nombre: 'Fisico'}, {id: 2, nombre: 'Digital'}];
        }else{
          this.opcionesFlujo = [{id: 1, nombre: 'Fisico'}];
        }
      }

    },
    siguiente(){
      this.$emit('siguiente', this.infoGeneral, 1);
    },

    reset(){
      this.infoGeneral.empleadoSeleccionado = null;
      this.infoGeneral.flujo = 1;
    }
  }
}
</script>
<style scoped>
.textSize {
  font-size: 0.8em;
}
</style>
